<div class="d-flex flex-column flex-root app-root" id="kt_app_root">
  <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
    <!--Header-->
    <app-header></app-header>
    <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
      <!--Sidebar-->
      <app-sidebar></app-sidebar>
      <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <router-outlet></router-outlet>
        <!--Footer-->
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</div>

<!--Scrolltop-->
<app-scroll-to-top></app-scroll-to-top>
